import { application } from '../constants'
// import { prepareBeacon } from './prepare-beacon'

/**
 * Setup PayPal Analytics (FPTI).
 * @param {String} fptiData Setup fpti with data provided by fptiSetup.js and modify from there
 */
export function setupPayPalAnalytics(fptiData) {
  const PAYPAL = window.PAYPAL || {}

  if (PAYPAL.analytics) {
    const options = fptiData || {}

    // differentiate between ddnw and dnw
    const pathList = window.location.pathname
      .replace(/(^\/|\/$)/g, '')
      .split('/')
    const component =
      pathList.length > 1 && pathList[0] === 'dashboard'
        ? 'devdashnodeweb'
        : 'devdiscoverynodeweb'

    // modifty FPTI data
    options.pgrp = null // don't need this to persist since its changes are captured elsewhere
    options.page = null // don't need this to persist since its changes are captured elsewhere
    options.comp = component
    options.env = application.env

    PAYPAL.analytics.setup({
      data: options,
      trackImpression: false,
    })
  }
}
